import ApiService from "../../../ApiService";

const ListService = {
    loadScreenView: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/messageboard/list/loadscreenview", { searchVO }, successCallback, failureCallback);
    },

    delete: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/messageboard/list/delete", vo, successCallback, failureCallback);
    },
};

export default ListService;